module.exports = __webpack_public_path__ + "assets/img/type_7.6ae0746a.png";